
import { defineComponent } from 'vue';
import router from '@/router/index';
export default defineComponent({
  setup() {
    const goBack = () => {
      router.go(-1);
    };
    const goHome = () => {
      router.push('/main');
    };
    return {
      goBack,
      goHome,
    };
  },
});
